import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Check } from "lucide-react";

export function DetailModal({ item, onClose }) {
  return (
    <Dialog open={!!item} onOpenChange={(v) => !v && onClose()}>
      <DialogContent
        className="bg-[#0D111D] border-white/10 text-slate-100 max-w-xl max-h-[85vh] overflow-y-auto"
        data-testid="detail-modal"
      >
        {item && (
          <>
            <DialogHeader>
              <div className="flex items-center gap-3.5 mb-1">
                {item.Icon && (
                  <div
                    className="w-11 h-11 rounded-xl flex items-center justify-center shrink-0"
                    style={{ background: `${item.accent}14`, border: `1px solid ${item.accent}33` }}
                  >
                    <item.Icon className="w-5 h-5" style={{ color: item.accent }} strokeWidth={1.8} />
                  </div>
                )}
                <div>
                  {item.kicker && (
                    <p className="font-mono-tech text-[10px] tracking-[0.3em] uppercase" style={{ color: item.accent }}>
                      {item.kicker}
                    </p>
                  )}
                  <DialogTitle
                    className="font-display text-xl sm:text-2xl font-bold text-white text-left"
                    data-testid="detail-modal-title"
                  >
                    {item.title}
                  </DialogTitle>
                </div>
              </div>
            </DialogHeader>
            <p className="text-sm sm:text-base text-slate-300 leading-relaxed mt-2" data-testid="detail-modal-text">
              {item.detail}
            </p>
            {item.bullets?.length > 0 && (
              <ul className="mt-5 space-y-2.5" data-testid="detail-modal-bullets">
                {item.bullets.map((b) => (
                  <li key={b} className="flex items-start gap-2.5 text-sm text-slate-200">
                    <Check className="w-4 h-4 mt-0.5 shrink-0" style={{ color: item.accent }} />
                    <span>{b}</span>
                  </li>
                ))}
              </ul>
            )}
          </>
        )}
      </DialogContent>
    </Dialog>
  );
}
